import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {BehaviorSubject, tap} from 'rxjs';
import {TimeAppSuppliesService} from '../services/time-app-supplies.service';
import {ServiceAppModels} from '../../../models/serviceapp-models';
import {MatTableDataSource} from '@angular/material/table';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FormControl} from '@angular/forms';
import {MatPaginator} from '@angular/material/paginator';
import Produkt = ServiceAppModels.Produkt;

type DisplayedColumns = 'productNo' | 'description' | 'pricePerQuantity' | 'searchKey' | 'lightweight';

@Component({
    selector: 'app-time-app-work-supply-product-list',
    templateUrl: './time-app-work-supply-product-list.component.html',
    styleUrl: './time-app-work-supply-product-list.component.scss'
})
export class TimeAppWorkSupplyProductListComponent implements AfterViewInit {
    @Output() productSelected: EventEmitter<Produkt | null> = new EventEmitter<Produkt | null>();
    @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
    @Input() displayedColumns: DisplayedColumns[] = ['productNo', 'description', 'pricePerQuantity', 'searchKey'];
    @Input() lightweight: boolean = false;
    protected searchString: FormControl = new FormControl('');
    protected products = new MatTableDataSource();
    protected selectedProductNumber = new BehaviorSubject('');

    constructor(private supplyService: TimeAppSuppliesService) {
        this.supplyService.getProducts().pipe(
            tap((data) => {
                this.products.data = data;
            })
        ).subscribe();
        this.searchString.valueChanges.pipe(
            takeUntilDestroyed(),
            tap((s) => {
                this.products!.filter = s.trim().toLowerCase();
            })
        ).subscribe();

        if (this.lightweight) {
            this.displayedColumns = ['lightweight'];
        }
    }

    ngAfterViewInit(): void {
        this.products.paginator = this.paginator!;
    }

    protected highlight(row: Produkt) {
        if (this.selectedProductNumber.getValue() == row.productNo) {
            this.selectedProductNumber.next('');
            this.productSelected.next(null);

        } else {
            this.selectedProductNumber.next(row.productNo);
            this.productSelected.next(row);
        }
    }
}
